import Vue from 'vue';
var $t = Vue.prototype.$t;

/** 疑似作弊行为详情：label → 取值字段（label 已翻译；单位由接口拼好） */
export var CHEAT_DETAIL_FIELDS = [{
  label: $t('24853_f43150e4'),
  field: 'altitude'
}, {
  label: $t('24853_3150e41d'),
  field: 'client_ip'
}, {
  label: $t('24853_150e41d6'),
  field: 'accuracy'
}, {
  label: $t('24853_50e41d61'),
  field: 'is_vpn'
}, {
  label: $t('24853_0e41d61a'),
  field: 'location_type'
}, {
  label: $t('24853_e41d61a1'),
  field: 'wifi_name'
}, {
  label: $t('24853_41d61a16'),
  field: 'client_device_time'
}, {
  label: $t('24853_1d61a16d'),
  field: 'client_timezone'
}, {
  label: $t('24853_d61a16d5'),
  field: 'is_root'
}];

/** 打卡设备详情：label → 取值字段（label 已翻译） */
export var DEVICE_DETAIL_FIELDS = [{
  label: $t('24853_61a16d53'),
  field: 'device_name'
}, {
  label: $t('24853_1a16d534'),
  field: 'os_version'
}, {
  label: $t('24853_a16d5340'),
  field: 'app_version'
}];